import React, { useState } from "react";

export default function CreateEnquiryModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-5xl p-6 shadow-lg overflow-y-auto max-h-[90vh]">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Create Enquiries</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black text-2xl"
          >
            ×
          </button>
        </div>

        {/* Form Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Product Name */}
          <div>
            <label className="text-sm font-medium">
              Product Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
              placeholder="ENTER PRODUCTS / SERVICES NAME"
            />
          </div>

          {/* Country */}
          <div>
            <label className="text-sm font-medium">
              Country <span className="text-red-500">*</span>
            </label>
            <div className="flex border">
              <span className="border px-3 py-2 rounded-l bg-gray-100 text-gray-500 flex items-center">
                <img
                  src="https://flagcdn.com/16x12/in.png"
                  alt="India flag"
                  className="inline-block mr-1"
                />
                +91
              </span>
              <select className="w-full outline-none focus:outline-none px-3 py-2 rounded appearance-none text-gray-500">
                <option>Select country</option>
                <option>India</option>
                <option>USA</option>
              </select>
            </div>
          </div>

          {/* Mobile Number */}
          <div>
            <label className="text-sm font-medium">
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <div className="flex">
              <span className="border px-3 py-2 rounded-l bg-gray-100 text-gray-500 flex items-center">
                <img
                  src="https://flagcdn.com/16x12/in.png"
                  alt="India flag"
                  className="inline-block mr-1"
                />
                +91
              </span>
              <input
                type="tel"
                className="w-full border border-l-0 px-3 py-2 rounded-r text-gray-500 outline-none focus:outline-none"
                placeholder="ENTER MOBILE NUMBER"
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="text-sm font-medium">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
              placeholder="ENTER EMAIL ADDRESS"
            />
          </div>

          {/* Company Name */}
          <div>
            <label className="text-sm font-medium">Your Company Name</label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
              placeholder="ENTER COMPANY NAME"
            />
          </div>

          {/* HSN Code */}
          <div>
            <label className="text-sm font-medium">HSN Code</label>
            <select className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none">
              <option>Select HSN CODE</option>
              <option>1234</option>
              <option>5678</option>
            </select>
          </div>

          {/* Quantity and Unit */}
          <div className="flex gap-4">
            <div className="flex-col w-full">
              <label className="text-sm font-medium">
                Quantity <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
                placeholder="ENTER Q.NO"
              />
            </div>
            <div className="flex-col w-full">
              <label className="text-sm font-medium">
                Unit <span className="text-red-500">*</span>
              </label>
              <select className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none">
                <option>Select Unit</option>
                <option>KG</option>
                <option>Box</option>
              </select>
            </div>
          </div>

          {/* Destination Port */}
          <div>
            <label className="text-sm font-medium">Destination Port</label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
              placeholder="Enter destination port"
            />
          </div>

          {/* Inco Term */}
          <div>
            <label className="text-sm font-medium">Inco Term</label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
              placeholder="Enter Inco Term"
            />
          </div>

          {/* Target Price */}
          <div>
            <label className="text-sm font-medium">Target Price</label>
            <div className="flex">
              <input
                type="number"
                className="w-full border px-3 py-2 rounded-l text-gray-500 outline-none focus:outline-none"
                placeholder="Enter target price"
              />
              <span className="border border-l-0 px-3 py-2 bg-gray-100 rounded-r text-gray-500">
                USD
              </span>
            </div>
          </div>

          {/* Negotiable */}
          <div className="w-full justify-center mt-4 ml-3 items-center flex-col">
            <label className="text-sm font-medium block">Negotiable</label>
            <div className="flex gap-4 mt-1">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="negotiable"
                  value="yes"
                  className="outline-none focus:outline-none"
                />
                Yes
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="negotiable"
                  value="no"
                  defaultChecked
                  className="outline-none focus:outline-none"
                />
                No
              </label>
            </div>
          </div>

          {/* Payment Term */}
          <div>
            <label className="text-sm font-medium">Payment Term</label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded text-gray-500 outline-none focus:outline-none"
              placeholder="Enter payment term"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
}
